import axios from '../http'

export default {
  //登录接口
  login(param) {
    return axios.post('/api/pt-backend/login/login', param)
  },
  getUserInfo() {
    return axios.post('/api/pt-backend/login/getUserInfo')
  },
  //获取验证码
  validateImage(param) {
    return axios.get('/api/pt-backend/login/validateImage', param)
  },
  //获取日志管理列表
  getLogList(param) {
    return axios.post('/api/pt-backend/logInfoManagement/getLogList', param)
  },
  //获取模块信息列表
  getModuleList(param) {
    return axios.post('/api/pt-backend/moduleInfoManagement/getModuleList', param)
  },
  //新增模块信息
  addModuleInfo(param) {
    return axios.post('/api/pt-backend/moduleInfoManagement/addModuleInfo', param)
  },
  //新增模块信息
  updateModuleInfo(param) {
    return axios.post('/api/pt-backend/moduleInfoManagement/updateModuleInfo', param)
  },
  //删除模块信息
  delModule(param) {
    return axios.delete('/api/pt-backend/moduleInfoManagement/delModule', param)
  },
  //移动模块信息
  moveModule(type, id) {
    return axios.get(`/api/pt-backend/moduleInfoManagement/moveModule/${type}/${id}`)
  },
  //获取分类信息管理列表
  getClassificationList(param) {
    return axios.post('/api/pt-backend/classificationManagement/getClassificationList', param)
  },
  //新增分类信息
  addClassification(param) {
    return axios.post('/api/pt-backend/classificationManagement/addClassification', param)
  },
  //编辑分类信息
  editClassification(param) {
    return axios.post('/api/pt-backend/classificationManagement/editClassification', param)
  },
  //删除分类信息
  delClassification(param) {
    return axios.delete('/api/pt-backend/classificationManagement/delClassification', param)
  },
  //获取品牌信息管理列表
  getBrandInfoList(param) {
    return axios.post('/api/pt-backend/brandInfoManagement/getBrandInfoList', param)
  },
  //新增品牌信息
  addBrandInfo(param) {
    return axios.post('/api/pt-backend/brandInfoManagement/addBrandInfo', param)
  },
  //编辑品牌信息
  editBrandInfo(param) {
    return axios.post('/api/pt-backend/brandInfoManagement/editBrandInfo', param)
  },
  //删除品牌信息
  delBrandInfo(param) {
    return axios.delete('/api/pt-backend/brandInfoManagement/delBrandInfo', param)
  },
  //获取大区信息管理列表
  getRegionalInfoList(param) {
    return axios.post('/api/pt-backend/regionalInfoManagement/getRegionalInfoList', param)
  },
  //修改大区信息状态管理列表
  switchState(id) {
    return axios.get(`/api/pt-backend/regionalInfoManagement/switchState/${id}`)
  },
  //新增大区信息
  addRegionalInfo(param) {
    return axios.post('/api/pt-backend/regionalInfoManagement/addRegionalInfo', param)
  },
  //编辑大区信息
  updateRegionalInfo(param) {
    return axios.post('/api/pt-backend/regionalInfoManagement/updateRegionalInfo', param)
  },
  //删除品牌信息
  delRegionalInfo(param) {
    return axios.delete('/api/pt-backend/regionalInfoManagement/delRegionalInfo', param)
  },
  //获取大区配置信息
  getRegionalConf(param) {
    return axios.post('/api/pt-backend/regionalInfoManagement/getRegionalConf', param)
  },
  //设置大区配置信息
  saveRegionalConf(param) {
    return axios.post('/api/pt-backend/regionalInfoManagement/saveRegionalConf', param)
  },
  //获取省市树
  getProvincesAndCitiesTree() {
    return axios.post('/api/pt-backend/localInformation/getProvincesAndCitiesTree')
  },
  //获取省市树
  getLocalList(param) {
    return axios.post('/api/pt-backend/localInformation/getLocalList', param)
  },
  //删除地域信息
  delLocal(param) {
    return axios.delete('/api/pt-backend/localInformation/delLocal', param)
  },
  //编辑地域信息
  editLocalInfo(param) {
    return axios.post('/api/pt-backend/localInformation/editLocalInfo', param)
  },
  //新增地域信息
  addLocalInfo(param) {
    return axios.post('/api/pt-backend/localInformation/addLocalInfo', param)
  },
  //获取学校列表
  getSchoolList(param) {
    return axios.post('/api/pt-backend/schoolInfoManagement/getSchoolList', param)
  },
  //删除学校信息
  delSchool(param) {
    return axios.delete('/api/pt-backend/schoolInfoManagement/delSchool', param)
  },
  //添加学校列表
  addSchoolInfo(param) {
    return axios.post('/api/pt-backend/schoolInfoManagement/addSchoolInfo', param)
  },
  //编辑学校列表
  saveEditSchoolInfo(param) {
    return axios.post('/api/pt-backend/schoolInfoManagement/saveEditSchoolInfo', param)
  },
  //获取下拉框选项
  getSelectOption(param) {
    return axios.post('/api/pt-backend/productInfo/getSelectOption', param)
  },
  //获取货品信息列表
  getProductList(param) {
    return axios.post('/api/pt-backend/productInfo/getProductList', param)
  },
  //新增货品信息
  addProductInfo(param) {
    return axios.post('/api/pt-backend/productInfo/addProductInfo', param)
  },
  //新增货品信息
  editProductInfo(param) {
    return axios.post('/api/pt-backend/productInfo/editProductInfo', param)
  },
  //更新货品状态
  changeProductSwitch(id) {
    return axios.get(`/api/pt-backend/productInfo/changeProductSwitch/${id}`)
  },
  //删除学校信息
  delProduct(param) {
    return axios.delete('/api/pt-backend/productInfo/delProduct', param)
  },
  //获取文件信息列表
  getFileInfoList(param) {
    return axios.post('/api/pt-backend/fileInfo/getFileInfoList', param)
  },
  //移动文件
  moveFile(param) {
    return axios.post('/api/pt-backend/fileInfo/moveFile', param)
  },
  //删除文件信息
  delFileInfo(param) {
    return axios.delete('/api/pt-backend/fileInfo/delFileInfo', param)
  },
  //新增文件信息
  addFileInfo(param) {
    return axios.post('/api/pt-backend/fileInfo/addFileInfo', param)
  },
  //编辑文件信息
  updateFileInfo(param) {
    return axios.post('/api/pt-backend/fileInfo/updateFileInfo', param)
  },
  //获取大版本列表
  getBigVersionList(param) {
    return axios.post('/api/pt-backend/productPlan/getBigVersionList', param)
  },
  //获取大版本列表表格
  getBigVersionListTable(param) {
    return axios.post('/api/pt-backend/productPlan/getBigVersionListTable', param)
  },
  //删除大版本
  delBigVersionInfo(param) {
    return axios.delete('/api/pt-backend/productPlan/delBigVersionInfo', param)
  },
  delSmallVersionInfo(param) {
    return axios.delete('/api/pt-backend/productPlan/delSmallVersionInfo', param)
  },
  //新增大版本信息
  addBigVersionInfo(param) {
    return axios.post('/api/pt-backend/productPlan/addBigVersionInfo', param)
  },
  //编辑大版本信息
  editBigVersionInfo(param) {
    return axios.post('/api/pt-backend/productPlan/editBigVersionInfo', param)
  },
  //获取大版本列表表格
  getSmallVersionListTable(param) {
    return axios.post('/api/pt-backend/productPlan/getSmallVersionListTable', param)
  },
  //新增大版本信息
  addSmallVersionInfo(param) {
    return axios.post('/api/pt-backend/productPlan/addSmallVersionInfo', param)
  },
  //编辑大版本信息
  editSmallVersionInfo(param) {
    return axios.post('/api/pt-backend/productPlan/editSmallVersionInfo', param)
  },
  //获取配置货品列表
  getConfGoodsList(param) {
    return axios.post('/api/pt-backend/configGoods/getConfGoodsList', param)
  },
  //编辑配置货品备注
  saveConGoodRemark(param) {
    return axios.post('/api/pt-backend/configGoods/saveConGoodRemark', param)
  },
  //编辑配置货品数量
  saveConGoodNum(param) {
    return axios.post('/api/pt-backend/configGoods/saveConGoodNum', param)
  },
  //开关是否必选
  saveMust(param) {
    return axios.get(`/api/pt-backend/configGoods/saveMust/${param}`)
  },
  //移动表格内项
  moveItem(param) {
    return axios.post('/api/pt-backend/configGoods/moveItem', param)
  },
  //移动大配置项内项
  moveCard(param) {
    return axios.post('/api/pt-backend/configGoods/moveCard', param)
  },
  //删除大模块
  delConfModule(param) {
    return axios.delete('/api/pt-backend/configGoods/delConfModule', param)
  },
  //删除产品
  delConfGoodsItem(param) {
    return axios.delete('/api/pt-backend/configGoods/delConfGoodsItem', param)
  },
  //获取添加模块的列表
  getConModuleList(param) {
    return axios.post('/api/pt-backend/configGoods/getConModuleList', param)
  },
  //添加模块
  addConfModule(param) {
    return axios.post('/api/pt-backend/configGoods/addConfModule', param)
  },
  //添加模块商品
  saveModuleGoods(param) {
    return axios.post('/api/pt-backend/configGoods/saveModuleGoods', param)
  },
  //获取备选货品列表
  getAlternativeGoods(param) {
    return axios.post('/api/pt-backend/configGoods/getAlternativeGoods', param)
  },
  //移动已选待选
  moveSelect(param) {
    return axios.post('/api/pt-backend/configGoods/moveSelect', param)
  },
}
